import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
// Add your imports here
import ChapterOverviewDashboard from "pages/chapter-overview-dashboard";
import QuizAssessmentInterface from "pages/quiz-assessment-interface";
import QuizResultsPerformanceAnalytics from "pages/quiz-results-performance-analytics";
import InteractivePresentationViewer from "pages/interactive-presentation-viewer";
import LearningProgressTracker from "pages/learning-progress-tracker";
import AuthenticationLogin from "pages/authentication-login";
import NotFound from "pages/NotFound";
import SelectQuizCourse from "pages/quiz-assessment-interface/select-quiz-course";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/authentication-login" element={<AuthenticationLogin />} />

          {/* Protected Routes */}
          <Route path="/" element={<ProtectedRoute><ChapterOverviewDashboard /></ProtectedRoute>} />
          <Route path="/chapter-overview-dashboard" element={<ProtectedRoute><ChapterOverviewDashboard /></ProtectedRoute>} />
          <Route path="/quiz-assessment-interface" element={<ProtectedRoute><SelectQuizCourse /></ProtectedRoute>} />
          <Route path="/quiz-assessment" element={<ProtectedRoute><QuizAssessmentInterface /></ProtectedRoute>} />
          <Route path="/quiz-results-performance-analytics/:id" element={<ProtectedRoute><QuizResultsPerformanceAnalytics /></ProtectedRoute>} />
          <Route path="/interactive-presentation-viewer" element={<ProtectedRoute><InteractivePresentationViewer /></ProtectedRoute>} />
          <Route path="/learning-progress-tracker" element={<ProtectedRoute><LearningProgressTracker /></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;